import React from "react";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import CnRegister from "../register";
import IntlRegister from "../intl/Register";

const WorkspaceRegister = () => {
  const { workspace } = useWorkspace();

  if (workspace === "intl") {
    return <IntlRegister key={workspace} />;
  }

  return <CnRegister key={workspace} />;
};

export default WorkspaceRegister;
